export enum SchedulingTypeEnum {
  DEFAULT = 'DEFAULT',
  CAMPAIGN = 'CAMPAIGN',
  ALERT = 'ALERT',
}

export enum PlaylistTypeEnum {
  DEFAULT = 'DEFAULT',
  CAMPAIGN = 'CAMPAIGN',
  ALERT = 'ALERT',
  CONDITIONAL = 'CONDITIONAL',
}
